import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Redirect, Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { authActions } from "../../../common/redux/actions";
import { globalService as gs } from '../../../common/services';
import { Main } from '../../layout';
import { DocumentTitle, Role } from '../../../helpers';
import moment from 'moment-timezone';

class Register extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            formField: {
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                date_of_birth: null,
                password: '',
                confirm_password: '',
                role: "User",
                terms: '',
            },
            loading: false,
            expired: "false",
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    componentDidMount() {

    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = { ...this.state.formField };
        formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        this.setState({ formField });
    };

    handleDateChange = (date) => {
        let formField = { ...this.state.formField };
        formField['date_of_birth'] = date
        this.setState({ formField });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        //console.log('formField', this.state.formField);
        if (this.validator.allValid()) {
            // handle actual form submission here
            const { dispatch } = this.props;
            let formField = { ...this.state.formField };
            formField.date_of_birth = moment(formField.date_of_birth).format('X');
            dispatch(authActions.register(formField, { role: Role.User }));
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    render() {
        this.validator.purgeFields();
        const { process } = this.props;
        if (gs.identity) {
            return (<Redirect to='/' />);
        }
        const { formField } = this.state;
        const { first_name, last_name, email, phone_number, password, confirm_password, terms, date_of_birth } = formField;

        return (<Main>
            <DocumentTitle title={`Register`} />
            <section className="login-page my-5 py-5" style={{ backgroundImage: `url(/images/register-new.png)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="login-box">
                                <h1 className="text-left mb-4">Sign Up</h1>
                                <form name="form" onSubmit={this.handleSubmit} noValidate>
                                    <div className="form-row">
                                        <div className="col-md-6 col-6">
                                            <div className="form-group">
                                                <label>First Name<span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" placeholder="Enter Your First Name" name="first_name" value={first_name} onChange={this.handleChange} />
                                                {this.validator.message('first_name', first_name, 'required')}
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-6">
                                            <label>Last Name<span className="text-danger">*</span></label>
                                            <div className="form-group">
                                                <input type="text" className="form-control" placeholder="Enter Your Last Name" name="last_name" value={last_name} onChange={this.handleChange} />
                                                {this.validator.message('last_name', last_name, 'required')}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="form-group">
                                        <label>Username<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Your Username" name="username" value={username} onChange={this.handleChange} />
                                        {this.validator.message('username', username, 'required|min:4|max:15')}
                                    </div> */}
                                    <div className="form-group">
                                        <label>Email<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Enter Your Email Address
                                        " name="email" value={email} onChange={this.handleChange} />
                                        {this.validator.message('email', email, 'required|email')}
                                    </div>
                                    <div className="form-group">
                                        <label>Date of Birth<span className="text-danger">*</span></label>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                inputVariant="outlined"
                                                InputProps={{
                                                    classes: { input: 'form-control pr-0' },
                                                    placeholder: 'Date of Birth',
                                                    disableUnderline: true
                                                }}
                                                rightArrowButtonProps={{
                                                    color: 'inherit'
                                                }}
                                                //TextFieldComponent={() => null}
                                                className="w-100 normal-input"
                                                name="date_of_birth"
                                                format="MM/dd/yyyy"
                                                margin="normal"
                                                id="date-picker-inline"
                                                value={date_of_birth}
                                                onChange={this.handleDateChange}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                maxDate={moment(new Date()).subtract(18, 'years')}
                                            />
                                        </MuiPickersUtilsProvider>
                                        <div className="mustbe">Must be 18 years old and over.</div>
                                        {this.validator.message('date_of_birth', date_of_birth, 'required')}
                                    </div>
                                    <div className="form-group">
                                        <label>Contact Number<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="phone_number" name="phone_number" value={phone_number} onChange={this.handleChange} />
                                        {this.validator.message('phone_number', phone_number, 'required')}
                                    </div>
                                    {/* <div className="form-group">
                                        <label>Postal Code</label>
                                        <input type="text" className="form-control" placeholder="Enter Your Postal Code" name="postcode" value={postcode} onChange={this.handleChange} />
                                        {this.validator.message('postcode', postcode, 'required')}
                                    </div> */}
                                    <div className="form-group">
                                        <label>Password<span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" placeholder="Password" name="password" value={password} onChange={this.handleChange} />
                                        {this.validator.message('password', password, 'required|min:6')}
                                    </div>
                                    <div className="form-group">
                                        <label>Confirm Password<span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" placeholder="Confirm Password" name="confirm_password" value={confirm_password} onChange={this.handleChange} />
                                        {this.validator.message('confirm_password', confirm_password, `required|in:${password}`)}
                                    </div>

                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name="terms" className="custom-control-input" id="customControlInline1" checked={(terms === 1) ? true : false} onChange={this.handleChange} />
                                            <label className="custom-control-label pl-2" htmlFor="customControlInline1"> I have read and agree to the <a target="_blank" rel="noopener noreferrer" href="/terms-condition">Terms &amp; Conditions</a></label>
                                        </div>
                                        {this.validator.message('terms', terms, 'required')}
                                    </div>

                                    <div className="form-group">
                                        <LaddaButton className="btn btn-primary py-3 font-weight-bold btn-block" loading={this.props.process.loading} data-style={EXPAND_RIGHT}>Register</LaddaButton>
                                    </div>
                                    {/* <div className="form-group d-flex justify-content-between">
                                        <button type="button" className="btn btn-facebook d-flex justify-content-center align-items-center">
                                            <div className="img">
                                            <img src="/images/svg/Facebook-login.svg" alt="Facebook" /> </div>Facebook 
                                            
                                        </button>
                                        <button type="button" className="btn btn-google d-flex justify-content-center align-items-center">
                                            <div className="img">
                                                <img src="/images/svg/Google.svg" alt="Google" /></div> Google
                                        </button>
                                    </div> */}
                                    <div className="form-group account text-center">
                                        <Link to="/become-a-tutor">Become a Tutor</Link>
                                    </div>
                                    <div className="form-group account text-center">
                                        Already have an Account? <Link to="/login">Please Login</Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <div className="col-lg-8 col-md-6 col-sm-6 col-12">
                            <div className="image">
                                <img className="img-fluid" src="/images/register.png" alt="Banner" />
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </Main>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    authSelector,
    processSelector,
    (authentication, process) => ({
        authentication, process
    })
);

export default connect(mapStateToProps)(Register);